export default __webpack_public_path__ + "images/Fetal_Abdominal_Standard_Plane_dark.8691f82ffdf4dd85874a8c7b0bef877a.png";